/** @format */

import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { HtmlSanitizerPipe } from '@shared/utils/pipes';
import { HmfAccordionComponent, HmfDrawerComponent } from '@dsg-tech/homefield-angular';
import {
	HomefieldIconLibraryModule,
	homefieldIconNatureWaves,
	HomefieldIconsLibraryService
} from '@dsg-tech/homefield-angular-icons';

@Component({
	selector: 'pdp-textile-label',
	templateUrl: './textile-label.component.html',
	styleUrl: './textile-label.component.scss',
	imports: [CommonModule, HmfAccordionComponent, HomefieldIconLibraryModule, HtmlSanitizerPipe]
})
export class TextileLabelComponent {
	@ViewChild('textileLabelDrawer') textileLabelDrawer: HmfDrawerComponent | undefined;
	@Input() textileLabel: string;

	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconNatureWaves]);
	}
}
